import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions.js";
import mutations from "./mutations.js";
import getters from "./getters.js";
import { NOW_LAMBDA_INFO, GOLF_LAMBDA_INFO } from "@/helpers/const";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    packageVersion: process.env.VERSION || "0",
    platformType: "pc",
    focusedView: "default",
    mouseActivated: false,
    uuid: "",
    deviceId: "",
    splashImgUrl: "",
    homeData: [],
    homeHash: null,
    keyInput: {},
    gameTypes: {},
    leagueList: {},
    roundList: {},
    leagueSeasonList: {},
    yearList: [],
    leagueVodList: {},
    programList: {},
    programDetailInfo: {},
    programDetailList: {},
    themeDetailInfo: {},
    themeDetailList: {},
    topBannerInfo: {},
    gameVodList: {},
    systemPopup: {},
    terms: [],
    loginId: "",
    userInfo: {},
    userSubscription: {},
    contentsPermission: {},
    services: {},
    lambdaInfo:
      process.env.VUE_APP_SERVICE_TYPE === "GOLF"
        ? GOLF_LAMBDA_INFO
        : NOW_LAMBDA_INFO,
    vodData: {},
    liveData: {},
    playbackData: {},
  },
  getters,
  actions,
  mutations,
});
